import { useEffect } from "react";

import { toast } from "@jti/core-components/components/Toaster";
import { translateBackendErrorCode } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { ArticleDataPartial } from "../ArticleRestrictedContent/ArticleRestrictedContent";

export interface PointsTriggerPropsType {
  articleId: string;
  isArticleRead: ArticleDataPartial["is_read"];
  setArticleData: React.Dispatch<React.SetStateAction<ArticleDataPartial>>;
  isInEditor?: boolean;
  pointsGranted: number;
}

export const PointsTrigger: React.FC<PointsTriggerPropsType> = (props: PointsTriggerPropsType) => {
  const { __, dictionary } = useTranslations();
  const { articleId, setArticleData, isArticleRead, isInEditor, pointsGranted } = props;
  const POINTS_TRIGGER = "pointsTrigger";
  const setIsRead = () => setArticleData((prevState) => ({ ...prevState, is_read: true }));

  useEffect(() => {
    const user = getUser();
    const isUserAuthenticated = user.uuid && user.ciam_token;
    const isArticleIdProvided = Boolean(articleId);

    if (isInEditor || isArticleRead || !isUserAuthenticated || !isArticleIdProvided) return;

    const pointsTrigger = document.getElementById(POINTS_TRIGGER);
    const handleIntersection = (entries: IntersectionObserverEntry[], self: IntersectionObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          LoyaltyApi.init()
            .readArticleAction(articleId, user.ciam_token, user.uuid)
            .then(() => {
              setIsRead();
              toast.success(__("loyalty.articlePoints.trigger.success", [pointsGranted]));
            })
            .catch((e) => {
              const error = translateBackendErrorCode(
                e.error_code,
                __("loyalty.articlePoints.trigger.error"),
                dictionary
              );
              toast.error(error);
            });

          self.disconnect();
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 1,
    });
    observer.observe(pointsTrigger!);
  }, []);
  return (
    <div className={POINTS_TRIGGER} id={POINTS_TRIGGER} data-testid={POINTS_TRIGGER}>
      {isInEditor &&
        "Points trigger component, this is not visible on publish. Points will be assigned when this component reach viewport."}
    </div>
  );
};
